<script>
    export let hidden
</script>
<div class="{hidden ? 'd-none' : 'd-block'} p-fixed inset-0 z-500">
        <div class="p-fixed inset-0 bg-shade"></div>
        <div class="d-flex justify-center items-center p-relative w-1/1 h-1/1">
            <div class="loading-ring p-relative">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
</div>

<style>
    .loading-ring {
        width: 80px;
        height: 80px;
    }
    .loading-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid #fff;
        border-radius: 50%;
        animation: loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #fff transparent transparent transparent;
    }
    .loading-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .loading-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .loading-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes loading-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
